import { render, staticRenderFns } from "./fl44-contract-supplementary-agreements-block.vue?vue&type=template&id=37b2587a&"
import script from "./fl44-contract-supplementary-agreements-block.vue?vue&type=script&lang=js&"
export * from "./fl44-contract-supplementary-agreements-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b2587a')) {
      api.createRecord('37b2587a', component.options)
    } else {
      api.reload('37b2587a', component.options)
    }
    module.hot.accept("./fl44-contract-supplementary-agreements-block.vue?vue&type=template&id=37b2587a&", function () {
      api.rerender('37b2587a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/fl44-contract-supplementary-agreements-block.vue"
export default component.exports